import * as React from "react";
import Icon from "./Icon";
import crossmark from "./cross-mark.png";

export default function CrossMark(): React.ReactElement {
  return <Icon src={crossmark} />;
}
